import { JsonEditorSchema } from "@/shared/JsonEditorSchema/models/JsonEditorSchema";
import { JsonEditorType } from "@/shared/JsonEditorSchema/models/JsonEditorType";
import { IQueueExecutionCustomTablesProp } from "@/shared/Executions/models/IQueueExecutionRequest";
import SchemaGenerator from "./SchemaGenerator";
import { TableFieldType } from "@/components/Tables/models/TableFieldType";


export class CustomTablesSchemaGenerator extends SchemaGenerator<IQueueExecutionCustomTablesProp> {

    public createRootSchema(): JsonEditorSchema<IQueueExecutionCustomTablesProp> {

        const rootSchema: JsonEditorSchema<IQueueExecutionCustomTablesProp> = {
            type: 'object',
            additionalProperties: false,
            properties: {
                tables: {
                    type: 'array',
                    items: {
                        type: 'object',
                        additionalProperties: true,
                        properties: {
                            type: { type: 'string' }
                        },
                        required: ["type"]
                    }
                }
            },
            required: ['tables'],
        };

        return rootSchema;
    }

    public mapType(fieldType: any): JsonEditorType | null {
        switch (fieldType) {
            case TableFieldType.Text:
            case TableFieldType.Select:
            case TableFieldType.SelectOrCreate:
            case TableFieldType.ColumnSelectOrCreate:
            case TableFieldType.ColumnSelect:
            case TableFieldType.SelectJson:
            case TableFieldType.ColorPicker:
            case TableFieldType.StringTemplate:
            case TableFieldType.RegularExpression:
            case TableFieldType.ParamSelect:
            case TableFieldType.ParamSelectOrCreate:
            case TableFieldType.ParamOrColumnSelect:
            case TableFieldType.ParamOrColumnSelectOrCreate:
            case TableFieldType.SelectDataSource:
            case TableFieldType.TableColumnTypeSelect:
                return 'string';
            case TableFieldType.Number:
                return 'number';
            case TableFieldType.Boolean:
                return 'boolean';
            case TableFieldType.Array:
            case TableFieldType.ArrayValues:
            case TableFieldType.MultiSelect:
            case TableFieldType.ColumnMultiSelect:
            case TableFieldType.ColumnMultiSelectOrCreate:
            case TableFieldType.ParamMultiSelect:
            case TableFieldType.ParamMultiSelectOrCreate:
            case TableFieldType.ParamOrColumnMultiSelect:
            case TableFieldType.ParamOrColumnMultiSelectOrCreate:
                return 'array';
            case TableFieldType.Object:
            case TableFieldType.Json:
                return 'object';
            default:
                return null;
        }
    }

    public populateVariants(schema: JsonEditorSchema<IQueueExecutionCustomTablesProp>, variants: Array<any>, options: any): void {

        schema.properties.tables!.items = {
            type: 'object',
            additionalProperties: options.additionalProperties,
            required: ['type'],
            allOf: variants.map((variant: any) => {
                const { type: _t, ...otherProps } = variant.properties;
                const typeValue = variant.properties.type?.enum?.[0];
                return {
                    if: {
                        properties: { type: { const: typeValue } },
                        required: ['type']
                    },
                    then: {
                        properties: otherProps,
                        ...(variant.required?.length > 1
                            ? { required: variant.required }
                            : {})
                    }
                };
            })
        };

    }
}

export default CustomTablesSchemaGenerator;
